import { ToolsCardGridView } from './tools-card-grid-view';
import { ToolsCardListView } from './tools-card-list-view';
import { ToolCardData } from '@/modules/gpt-chats/types/tools.service.type';

export const ToolsCard = ({
  tool,
  view,
  copiedBlocksTool,
}: {
  tool: ToolCardData;
  view: 'list' | 'grid';
  copiedBlocksTool: boolean;
}) => {
  if (view == 'grid') return <ToolsCardGridView tool={tool} copiedBlocksTool={copiedBlocksTool} />;
  return <ToolsCardListView tool={tool} copiedBlocksTool={copiedBlocksTool} />;
};
